"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const material_1 = require("@mui/material");
const StyledGridItem = (0, material_1.styled)(material_1.Grid)(() => ({
    padding: "6px 16px",
    borderBottom: "1px solid rgba(0, 0, 0, 0.09)",
}));
const InfoGridItem = (props) => {
    const { width = 3, itemClasses = {}, name, value = "", secondaryValue = "", } = props;
    return (react_1.default.createElement(StyledGridItem, { item: true, xs: width, classes: itemClasses },
        react_1.default.createElement(material_1.Typography, { variant: "caption", color: "textSecondary" }, name),
        !react_1.default.isValidElement(value) && (react_1.default.createElement(material_1.Typography, { variant: "body2" }, value)),
        react_1.default.isValidElement(value) && react_1.default.createElement("div", null, value),
        react_1.default.createElement(material_1.Typography, { variant: "caption", color: "textSecondary" }, secondaryValue)));
};
exports.default = InfoGridItem;
